import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
export function DefaultListElementContextContainer(props) {
    var index = props.index, children = props.children;
    return (React.createElement(RampWithNameTransform, { rampName: "ElementIndexProvider", index: index },
        React.createElement(RampWithNameTransform, { rampName: "ElementPrimaryKeyProvider" }, children)));
}
